/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_MarkersInputs */

const en_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markers`)
};

const fr_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqueurs`)
};

const de_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markierungen`)
};

const it_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcatori`)
};

const ru_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркеры`)
};

const es_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores`)
};

const zh_cn2_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记`)
};

const ja_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカー`)
};

const hi_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्करों`)
};

const pt_pt2_options_quicktools_markers = /** @type {(inputs: Options_Quicktools_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores`)
};

/**
* | output |
* | --- |
* | "Markers" |
*
* @param {Options_Quicktools_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_markers = /** @type {((inputs?: Options_Quicktools_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_markers(inputs)
	if (locale === "de") return de_options_quicktools_markers(inputs)
	if (locale === "it") return it_options_quicktools_markers(inputs)
	if (locale === "ru") return ru_options_quicktools_markers(inputs)
	if (locale === "es") return es_options_quicktools_markers(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_markers(inputs)
	if (locale === "ja") return ja_options_quicktools_markers(inputs)
	if (locale === "hi") return hi_options_quicktools_markers(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_markers(inputs)
	return en_options_quicktools_markers(inputs)
});